import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-bg--gray--pc c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-j03-a-header" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "p-the-page-j03-a" }
const _hoisted_7 = { class: "p-the-page-j03-a__inner" }
const _hoisted_8 = { class: "p-the-page-j03-a__item" }
const _hoisted_9 = {
  key: 0,
  class: "p-the-page-j03-a__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_IconArrowLeft3sticks = _resolveComponent("IconArrowLeft3sticks")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_J03AResultScreen = _resolveComponent("J03AResultScreen")!
  const _component_PageNavi = _resolveComponent("PageNavi")!
  const _component_TheTemplateJ = _resolveComponent("TheTemplateJ")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheTemplateJ, {
          heading: false,
          "indicated-item": ['search', 'button'],
          "search-keyword": _ctx.searchKeyword,
          onDoSearch: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doSearch($event)))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("a", {
                href: _ctx.backUrl,
                class: "p-the-page-j03-a-header__icon"
              }, [
                _createVNode(_component_IconBase, {
                  width: 24,
                  height: 24,
                  "view-box": "0 0 24 24"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconArrowLeft3sticks)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_5),
              _createVNode(_component_CommonHeading, null, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("メッセージ一覧", -1)
                ])),
                _: 1,
                __: [1]
              })
            ])
          ]),
          contents: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_J03AResultScreen, {
                    "result-array": _ctx.usersSearchResults,
                    exclude: _ctx.excludeContents,
                    heading: _ctx.heading,
                    "section-type": _ctx.sectionType,
                    "messages-search-results-count": _ctx.messagesSearchResultsCount
                  }, null, 8, ["result-array", "exclude", "heading", "section-type", "messages-search-results-count"])
                ])
              ]),
              (_ctx.maxPage > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_PageNavi, {
                      "current-page": _ctx.currentPage,
                      "next-page-url": _ctx.nextPageUrl,
                      "prev-page-url": _ctx.prevPageUrl,
                      "max-page": _ctx.maxPage,
                      "base-url": _ctx.baseUrl,
                      search: _ctx.searchKeyword
                    }, null, 8, ["current-page", "next-page-url", "prev-page-url", "max-page", "base-url", "search"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["search-keyword"])
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}